import { render, staticRenderFns } from "./ItemDropList.vue?vue&type=template&id=70b36128&scoped=true&"
import script from "./ItemDropList.vue?vue&type=script&lang=ts&"
export * from "./ItemDropList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemDropList.vue?vue&type=style&index=0&id=70b36128&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b36128",
  null
  
)

export default component.exports